<template>
  <div class="ui_headPicWrapper">
    <div
      class="ui_headPic"
      v-bind:style="{backgroundImage:'url(' + datas.picUrl + ')'}"
      @touchstart="touchstart"
      @touchend="touchend"
    >
      <template v-if="datas.isLogo">
        <template v-if="datas.csstype=='pic'">
          <img :src="datas.logoUrl" alt class="logo" />
        </template>
        <template v-else>
          <p class="logoText">{{datas.logoText}}</p>
        </template>
      </template>
    </div>
    <div class="pic" v-if="datas.hasPic">
      <img :src="datas.imgUrl" @click="goPage">
    </div>
  
    <div class="arrowBtn" @click.stop="toNextPage"></div>
  </div>
</template>

<script>
import { jAlert3, jAlert5 } from "@/base/jAlert/jAlert";
// 菜单项

export default {
  name: "HeadPic",
  props: ["datas"],
  data() {
    return {
      picUrl:
        "https://website-10065452.image.myqcloud.com/922db717-27d1-4a3d-a4c8-f38a467d3295",
      logoUrl:
        "https://website-10065452.image.myqcloud.com/22f21613-3c74-4582-9da5-68aba6b61b60",
      startX: "",
      startY: "",
      isStrat: false
    };
  },
  methods: {
    toNextPage() {
      window.scrollTo({
        //top: window.screen.availHeight,
        top: document.querySelector(".ui_headPic").clientHeight,
        behavior: "smooth"
      });
    },
    goPage(){
      if(this.datas.picLink&&this.datas.picLink!=''){
        window.location.href = this.datas.picLink
      }
      
    },
    //获得角度
    getAngle(angx, angy) {
      return (Math.atan2(angy, angx) * 180) / Math.PI;
    },
    //根据起点终点返回方向 1向上 2向下 3向左 4向右 0未滑动
    getDirection(startx, starty, endx, endy) {
      var angx = endx - startx;
      var angy = endy - starty;
      var result = 0;
      //如果滑动距离太短
      if (Math.abs(angx) < 2 && Math.abs(angy) < 2) {
        return result;
      }
      var angle = this.getAngle(angx, angy);
      if (angle >= -135 && angle <= -45) {
        result = 1;
      } else if (angle > 45 && angle < 135) {
        result = 2;
      } else if (
        (angle >= 135 && angle <= 180) ||
        (angle >= -180 && angle < -135)
      ) {
        result = 3;
      } else if (angle >= -45 && angle <= 45) {
        result = 4;
      }
      return result;
    },
    touchstart(e) {
      this.startx = e.touches[0].pageX;
      this.starty = e.touches[0].pageY;
    },
    touchend(e) {
      var _this = this;
      var endx, endy;
      endx = e.changedTouches[0].pageX;
      endy = e.changedTouches[0].pageY;
      var direction = this.getDirection(this.startx, this.starty, endx, endy);
      switch (direction) {
        case 0:
          console.log("未滑动！");
          break;
        case 1:
          _this.toNextPage();
          console.log("向上！");
          break;
        case 2:
          console.log("向下！");
          break;
        case 3:
          console.log("向左！");
          break;
        case 4:
          console.log("向右！");
          break;
        default:
      }
    }
  },
  mounted() {
    console.log(this.datas)
  }
};
</script>
<style lang="less" scoped>
@-webkit-keyframes rotate {
  0% {
    bottom: 15px;
  }

  25% {
    bottom: 12px;
  }

  50% {
    bottom: 8px;
  }

  75% {
    bottom: 10px;
  }

  90% {
    bottom: 14px;
  }

  100% {
    bottom: 16px;
  }
}

.ui_headPicWrapper {
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 11;
  .arrowBtn {
    width: 50px;
    height: 50px;
    position: absolute;
    bottom: 20px;
    left: 50%;
    margin-left: -25px;
    animation: rotate 1s infinite linear;
    transition: all 0.5s;
    background: url("https://xcx.ihotel.cn/hotel/images/indexArrow.png")
      no-repeat;
    background-size: 50px 50px;
    //background-position: 17px 16.5px;
    z-index: 1;
  }

  .ui_headPic {
    width: 100vw;
    height: 100vh;
    background-size: cover;
    background-position-x:center;
    position: relative;

    .logo {
      top: 20px;
      left: calc((100vw - 106px) / 2);
      //height: 36px;
      width: 106px;
      position: absolute;
    }

    .logoText {
      top: 20px;
      display: block;
      text-align: center;
      color: #fff;
      font-size: 16px;
      position: absolute;
      width: 100%;
    }
  }
  .pic{
    position: absolute;
    bottom: 2rem;
    left: 5%;
    width: 90%;
    
    img{
      width: 100%;
      height: auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/polymerization/HeadPic.vue